module.exports = __webpack_public_path__ + "static/media/mem5.ed5f6c36.jpg";